import { render, staticRenderFns } from "./function_menu.vue?vue&type=template&id=bf4eadce&scoped=true"
import script from "./function_menu.vue?vue&type=script&lang=js"
export * from "./function_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4eadce",
  null
  
)

export default component.exports